<template lang="pug">
    div.tab-pane(:class="tabPaneClass")
        slot
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import { TabsProvder } from '@/backoffice/legacy/mixins/design/tabs';

@Component({
  name: 'regular-tab',
})
export default class RegularTab extends Vue {
    @Prop({
      default: 'Безымянная вкладка',
    })
    tabTitle!: string

    tabId: any = null

    @Inject('tabsProvider')
    tabsProvider!: TabsProvder

    mounted() {
      this.registerTab();
    }

    registerTab() {
      this.tabId = this.tabsProvider.registerTab(this.tabTitle, this);
    }

    toggleThisTab() {
      this.tabsProvider.toggleTab(this.tabId);
    }

    get tabClass(): any {
      return {
        active: this.isActive,
      };
    }

    get tabPaneClass(): any {
      return {
        active: this.isActive,
      };
    }

    get isActive(): boolean {
      return this.tabsProvider.isActive(this.tabId);
    }
}
</script>

<style scoped lang="less">

</style>
